/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Habit_BodyInputs */

const en_for_whom_habit_body = /** @type {(inputs: For_Whom_Habit_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A reminder the day before a visit and your day's plan in the morning, so training never drops out of the week.`)
};

const pl_for_whom_habit_body = /** @type {(inputs: For_Whom_Habit_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przypomnienie dzień przed wizytą i plan dnia rano, żeby trening nie wypadał z tygodnia.`)
};

/**
* | output |
* | --- |
* | "A reminder the day before a visit and your day's plan in the morning, so training never drops out of the week." |
*
* @param {For_Whom_Habit_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_habit_body = /** @type {((inputs?: For_Whom_Habit_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Habit_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_habit_body(inputs)
	return en_for_whom_habit_body(inputs)
});